export { default as Heading } from './component';
export { useHeading } from './hook';
